import request from "@/utils/request";
import ENDPOINT from "@/config/endpoint";

export async function fetchFeedback(params) {
  return await request({
    url: ENDPOINT.FEEDBACK,
    method: "get",
    params,
  });
}
